import { observable } from 'mobx'
import lscache from 'lscache'
import MovimentacaoService from '../../../../services/MovimentacaoService'

export default class CamposExibicaoStore {

    @observable filtrosSalvos //semelhante a predefinicoes em programacao de navios
    @observable filtroSelecionado
    @observable filtrosVisualizacao
    @observable filtrosAntigos

    @observable todosCampos;
    @observable camposAtivos
    @observable todosCamposIds;
    @observable limiteCamposAtingido

    @observable filtroNomeAnterior
    @observable filtroDescAnterior
    @observable mostrarEditarFiltroNome

    filtroAnterior
    qtdAtivos

    constructor(){
        this.MovimentacaoService = new MovimentacaoService()
        this.camposObrigatorios = this.MovimentacaoService.obrigatorioMovimentacao;
        
        this.todosCampos = []
        this.camposAtivos = []
        this.todosCamposIds = new Set();

        this.limiteCamposAtingido = false
        this.qtdAtivos = this.camposAtivos.length

        this.filtrosVisualizacao = []
        this.filtrosAntigos = []
        this.filtroSelecionado = 0

        this.qtdAtivos = this.camposObrigatorios.length
        this.mostrarEditarFiltroNome = false

        this.carregarTodosCampos()
        this.carregarCampos()
    }

    carregarTodosCampos = () => {
        this.MovimentacaoService.listarTodosCampos(lscache.get('MembershipuserId')).then(response => {
            response.data.map(e => {
                if (!this.todosCamposIds.has(e.Codigo)) {
                    this.todosCamposIds.add(e.Codigo);
                    this.todosCampos.push({ id: e.Codigo, label: e.Descr });
                }
            })
            //this.camposAtivos = response.data.filter(elem => elem.Selected).map(elem => elem.Descr)
            //this.camposObrigatorios = response.data.filter(elem => elem.Enabled = false).map(elem => elem.Descr)
            //this.calculaQtdAtivos()

        }).catch(err => console.log(err))
    };

    carregarCampos = () => {
        this.MovimentacaoService.listarFiltros(lscache.get('MembershipuserId')).then(response => {
            response.data.map(f => { // TODO apenas para alteração do padrão anterior remover quando for seguro
                let fi = JSON.parse(f.ValorObjeto);
                if (fi.dadosTabela.includes("Cod. Armador")) {
                    f.ValorObjeto = "{\"valor\":0,\"nome\":\"Padrão\",\"descricao\":\"\",\"dadosTabela\":[\"Container\",\"ArmId\"]}";
                }
            });

            this.filtrosAntigos = response.data
            this.filtrosVisualizacao = response.data
            
            if (this.filtrosVisualizacao.length){
                //carrega os filtros já salvos

                //procura o filtro selecionado

                this.filtrosVisualizacao.find((elem, index) => {
                    const parsed = JSON.parse(elem.ValorObjeto)
                    
                    if(parsed.valor === 1){
                        this.filtroSelecionado = index
                        return index
                    }else{
                        this.filtroSelecionado = 0
                        return 0
                    }
                })

                this.filtrosSalvos = []

                this.filtrosVisualizacao.forEach(f => {
                    this.filtrosSalvos.push(JSON.parse(f.ValorObjeto))
                })
                
                
                if(this.filtrosSalvos.indexOf(this.filtrosSalvos.find((elem) => elem.valor === 1)) === -1){
                    this.filtroSelecionado = 0
                }else{
                    this.filtroSelecionado = this.filtrosSalvos.indexOf(this.filtrosSalvos.find((elem) => elem.valor === 1))
                }
                
                this.camposAtivos = this.filtrosSalvos[this.filtroSelecionado].dadosTabela

            }else{
                //Se não há filtros, então crie um novo filtro default
                this.filtrosSalvos = []
                let i = this.filtrosVisualizacao.length
                for(i; i < 3;i++){
                    this.filtrosVisualizacao[i] = this.MovimentacaoService.novoFiltro
                    this.filtrosVisualizacao[i].MembershipuserId = lscache.get('MembershipuserId')
                    this.filtrosVisualizacao[i].ValorObjeto = this.MovimentacaoService.novoValor
                    
                }   
                
                
                const novoFiltro = this.MovimentacaoService.novoValor
                this.camposAtivos = novoFiltro.dadosTabela
                
                this.filtrosVisualizacao.forEach(f => {
                    this.filtrosSalvos.push(f.ValorObjeto)
                })
                this.calculaQtdAtivos()
            }
        }).catch(error => console.log(error))
    }

    clickCheckboxCampo = (index) =>{
        let indexCampoChecked = this.camposAtivos.indexOf(this.camposAtivos.find((item) => item === index.id));

        if(indexCampoChecked !== -1){
            this.camposAtivos = this.camposAtivos.filter((value, i) => i !== indexCampoChecked)
        } else {
            this.camposAtivos.push(index.id)
        }

        this.filtrosSalvos[this.filtroSelecionado].dadosTabela = this.camposAtivos
        this.calculaQtdAtivos()

    }

    clickFiltro = (index) => {
        this.filtroSelecionado = index
        this.camposAtivos = this.filtrosSalvos[this.filtroSelecionado].dadosTabela

        this.calculaQtdAtivos()
    }

    calculaQtdAtivos = () => {
        this.qtdAtivos = this.camposAtivos.length

    }

    selecionarTodosOsCampos = () => {
        this.camposAtivos = this.todosCamposIds
        this.filtrosSalvos[this.filtroSelecionado].dadosTabela = this.camposAtivos
        this.calculaQtdAtivos()

    }

    limparTodosOsCampos = () => {
        this.camposAtivos = this.camposObrigatorios
        this.filtrosSalvos[this.filtroSelecionado].dadosTabela = this.camposAtivos
        this.calculaQtdAtivos()

    }

    salvarFiltro = () => {

        this.filtrosVisualizacao.map((elem,index) => {
            elem.NomeObjeto = ""
            if(index === this.filtroSelecionado){
                this.filtrosSalvos[index].valor = 1
            }else{
                this.filtrosSalvos[index].valor = 0

            }
            elem.ValorObjeto = JSON.stringify(this.filtrosSalvos[index])
            this.MovimentacaoService.salvarFiltro(elem)
                .then(data => {
                    //console.log('filtro salvo')
                })
                .catch(err => console.log(err))
        })
        // Como quando salva fecha a tela, eu tenho que ter alguma forma de resetar esse valor
        this.carregarCampos()
    }

    editarFiltroNomeClick = () => {
        this.filtroNomeAnterior = this.filtrosSalvos[this.filtroSelecionado].nome
        this.filtroDescAnterior = this.filtrosSalvos[this.filtroSelecionado].descricao
        this.mostrarEditarFiltroNome = true
    }

    salvarNovoNome = () => {
        this.mostrarEditarFiltroNome = false
    }

    cancelarNovoNome = () => {
        this.filtrosSalvos[this.filtroSelecionado].nome = this.filtroNomeAnterior
        this.filtrosSalvos[this.filtroSelecionado].descricao = this.filtroDescAnterior
        this.mostrarEditarFiltroNome = false
    }

    mudarNomePred = (e) => { this.filtrosSalvos[this.filtroSelecionado].nome = e.target.value }

    mudarDescPred = (e) => { this.filtrosSalvos[this.filtroSelecionado].descricao = e.target.value }


    sairModalLimite = () => { this.limiteCamposAtingido = false }

    cancerlarFiltros = () => {
        this.filtrosVisualizacao = this.filtrosAntigos
        this.carregarCampos()
    }

}


// WEBPACK FOOTER //
// ./src/modules/consultas/movimentação/stores/CamposExibicaoStore.js